export default {
    cities: [],
    cities_by_state_id: [],
}
